import type { ReactElement } from 'react'
import styled from 'styled-components'

import { ImageTitleLayout } from '@/components/enlayout'
import { CompanyLinks } from '@/components/enlayouts/Company/CompanyLinks'
import { Head } from '@/components/enlayouts/Head'

export const CompanyPage = () => {
  return (
    <>
      <CompanyMain>
        <CompanyLinks padding={{ pc: '0 0', sp: '0 0' }} />
      </CompanyMain>
    </>
  )
}

CompanyPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Corporate Information', path: '' },
  ]
  return (
    <>
      <Head
        title="Corporate Information"
        description="Corporate information for TRIAL Holdings, Inc."
        ogp={{ url: 'en/company/' }}
      />
      <ImageTitleLayout
        title=""
        subTitle=""
        enTitle="Corporate Information"
        imgUrl="/images/top-company.webp"
        breadCrumbs={breadCrumbs}
        isRequiredBackground
      >
        {page}
      </ImageTitleLayout>
    </>
  )
}

const CompanyMain = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 98px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 70px;
  }
`
